/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_c3_99_51 as Componente_c3_99_51,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_s3_115_51(e) {
  let t = (0, ReactCompiler.c)(4),
    { alertas: n } = e,
    r;
  t[0] === n
    ? (r = t[1])
    : ((r = n.map(Componente_c3_99_51)), (t[0] = n), (t[1] = r));
  let i;
  return (
    t[2] === r
      ? (i = t[3])
      : ((i = <span className={`flex flex-wrap gap-1`} children={r} />),
        (t[2] = r),
        (t[3] = i)),
    i
  );
}
